<template>
  <div class="ad-node ad-node--side ad-node--config">
    <Handle id="out" type="source" :position="Position.Right" />

    <div class="ad-node__visual">
      <img v-if="data.logo" :src="data.logo" class="ad-node__visual-logo" :alt="data.name" />
      <Icon v-else :name="data.icon" class="w-5 h-5" />
    </div>
    <div class="ad-node__body">
      <div class="ad-node__name" :title="data.name">{{ data.name }}</div>
      <div v-if="data.subtitle" class="ad-node__subtitle" :title="data.subtitle">{{ data.subtitle }}</div>
    </div>
  </div>
</template>

<script>
import { Handle, Position } from '@vue-flow/core';
import Icon from '@/ui-components/Icon.vue';

export default {
  name: 'ConfigNode',
  components: { Handle, Icon },
  props: {
    data: { type: Object, default: () => ({}) },
  },
  data() {
    return { Position };
  },
};
</script>
